module.exports = __webpack_public_path__ + "img/quality-banner-mobile.bac7c65d.png";